import { Textarea } from '@mantine/core';
import classNames from 'theme/components/Inputs/Textarea/Textarea.module.css';

export default Textarea.extend({
  classNames,
});
